const EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu;

function wrap(line, width) {
  const words = line.split(/\s+/).filter(Boolean);
  const out = [];
  let cur = '';
  for (const w of words) {
    if (cur && (cur + ' ' + w).length > width) { out.push(cur); cur = w; } else cur = cur ? `${cur} ${w}` : w;
  }
  if (cur) out.push(cur);
  return out;
}

// Plain text for teleprompter apps: no hashtags, emojis, links or markdown; one sentence per line, short lines.
export function toTeleprompterText(raw, width = 42) {
  const cleaned = (raw || '')
    .replace(EMOJI_RE, '')
    .replace(/https?:\/\/\S+/g, '')
    .replace(/(^|\s)#[\w-]+/g, '$1')
    .replace(/(^|\s)@[\w.]+/g, '$1')
    .replace(/\[(.*?)\]\((.*?)\)/g, '$1')
    .replace(/[*_`>~]+/g, '')
    .replace(/^\s*[-•▪◦]\s+/gm, '')
    .replace(/[ \t]+/g, ' ');
  const paragraphs = cleaned.split(/\n\s*\n/).map((p) => p.replace(/\n/g, ' ').trim()).filter(Boolean);
  return paragraphs
    .map((p) => p.split(/(?<=[.!?])\s+/).flatMap((s) => wrap(s.trim(), width)).join('\n'))
    .join('\n\n')
    .trim() + '\n';
}

export function downloadTxt(filename, text) {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(filename || 'teleprompter').replace(/[^\w-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'teleprompter'}.txt`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
